import * as React from 'react';

import { Button } from '@mq/aurora-components/dist/button';

import * as styles from './update-card.css';

export interface IUpdateCardProps {
  leftImage?: string;
  rightImage?: string;
}

export class UpdateCard extends React.PureComponent<IUpdateCardProps, {}> {
  handleMarqueeRoute = () => {
    window.location.href = 'https://marquee.gs.com/';
  };

  render() {
    return (
      <div className={styles.updateCard} style={{ padding: '0px', maxWidth: '704px' }}>
        <h1>Welcome to Marquee</h1>
        <p>The GS360 content you’re accessing has moved to Marquee.</p>
        <p>
          Marquee provides institutional investors with leading market intelligence, risk analytics,
          proprietary datasets, and trade execution across multiple asset classes.
        </p>
        <p>Please update your bookmarks after continuing to Marquee.</p>

        <div className={styles.updateCardSectionBottom}>
          <Button
            onClick={this.handleMarqueeRoute}
            size="large"
            type="primary"
            style={{ maxWidth: '352px', width: '100%' }}
          >
            Continue to Marquee
          </Button>
        </div>
        <div className={styles.updateCardDisclaimer}>
          <small>If you are prompted to log in, please provide your GS360 credentials.</small>
        </div>
      </div>
    );
  }
}
